    
<template>
  <span v-if="tempbusiness">
     

        

         <large-button v-if="tempbusiness.name" @click="saveBusinessConfig">Save Config</large-button> 
      
        <p>
          <label for="open">Name</label>
          <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.name"/>  
          <font color="red">Required. Warning changing the name will affect layouts in menus.</font>
        </p>        
        <p>
          <label for="open">Assets</label>
          <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.assets"/>  
          <font color="red">Required. Warning affects the main styling.</font>
        </p>        
        <p>
          <label for="open">Subdomain  (Optional)</label>
          <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.subdomain"/>  
          <font color="green">Used for subdomains, i.e fibi.works/businessname or businessname.fibi.works, the later requires dns setup</font>
        </p>
        <p>
          <label for="open">Domain  (Optional)</label>
          <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.domain"/>  
          <font color="green">Use full domain when not using FIBI.works domain. i.e. www.business.co.nz requires dns setup</font>
        </p>        
        
        <p>
          <label for="open">Short Name</label>
          <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.shortname"/>  
          <font color="green">Used to display short name for display only.</font>          
        </p>        
        <p>
          <label class="w3-text-grey">SMS</label>
          <input type="tel" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.phonesms"/>
          <font color="green">Under development.</font>
        </p>
    
       
        <p>
          <label class="w3-text-grey">Resolve Remedials
              <input id="default" class="w3-check" type="checkbox" v-model="tempbusiness.resolveremedials">                            
          </label> 
        </p>
        <p>
          <label class="w3-text-grey">Create Remedials
              <input id="default" class="w3-check" type="checkbox" v-model="tempbusiness.createremedials">                            
          </label> 
        </p>
        
        <p>
          <label class="w3-text-grey">Hide Help
              <input id="default" class="w3-check" type="checkbox" v-model="tempbusiness.hidehelp">                            
          </label> 
        </p>
    
        <span v-if="tempbusiness.pwa">
          <h3>Navigation/Labels</h3>
          <p>
            <label class="w3-text-grey">Label Cart/Time</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.pwa.labels.cart.pickuptime"/>
          </p>

          <p>
            <label class="w3-text-grey">Navigation/About</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.pwa.menus.about"/>
          </p>

          <p>
            <label class="w3-text-grey">Navigation/Home</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.pwa.menus.home"/>
          </p>

          <p>
            <label class="w3-text-grey">Navigation/Menu</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="tempbusiness.pwa.menus.menu"/>
          </p>
        </span>
   

  </span>
</template>


<script>

  import {
    mapGetters,
    mapActions
  } from "vuex";
  // var mounted=true;
  export default {
    props:["business"],
    data: function() {
      return {
        tempbusiness:null
      };
    },
    methods: {      
      saveBusinessConfig(){          
          this.businesscommands({command:'saveBusinessConfig',business:this.tempbusiness})
      },
      ...mapActions(["businesscommands","enableBusinesssAccount","enableBusinessPositions"])
    },
    computed: {
      ...mapGetters(["sysadmin"])
    },
    created(){
      this.tempbusiness = _.cloneDeep(this.business)
    }
  };
</script>
 
<style>

  textarea {
    width: 100%;
    height: 150px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    resize: none;
  }
  
  .description {
    padding-bottom: 10px;
    text-align: center;
  }
  
  .groupings {
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminCommonConfig.vue